import React from "react";
import Button from "../../common/Button/Button";
import "./hero-content.css";

function HeroContent({ isMobile }) {
  return (
    <>
      <h1 className="hero-title mb-10 md:mb-20 lg:max-w-md xxl:max-w-xl 2xl:max-w-3xl">
        Crypto betting
        <br />
        <span
          className="bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-teal-400"
          style={{ color: "#6E4CD1" }}
        >
          for everyone
        </span>
      </h1>
      <div className="lg:max-w-md xxl:max-w-xl 2xl:max-w-3xl">
        <p className="mb-8 description">
          Make crypto predictions and earn money easy and fun!{isMobile && <br/>} Try
          user-friendly, intuitive, real-time betting platform.
        </p>
        <Button text="Start Betting Now!" className="bg-amber-200" />
      </div>
    </>
  );
}

export default HeroContent;
